/*global VeloxFormController, palette, VeloxWebView*/
var ControllerWithImage = require("../../util/ControllerWithImage") ;
var uuid = require("uuid") ;
/**
 * This is a basic MVC grid/form controller
 * 
 * It creates 2 routes : #exploded/list and #exploded/form
 */
var explodedController = new ControllerWithImage("exploded", {
    grid : {
        directory: "views/exploded",
        name: "explodedGrid",
    },
    form : {
        directory: "views/exploded",
        name: "explodedForm",
        fileAccept: "image/svg+xml",
        sizeLimit: 3000000,
        joinFetch: [
            {otherTable: "device", joins: [
                {otherTable: "link_part_device", type:"2many", name: "parts", orderBy: "p_ref", joins: [
                    {otherTable: "part", flatten: true, joins : [
                        {otherTable: "part_exploded_position", name: "position", joinSearch: {e_id: "$pk"}, flatten: true},
                        { 
                            otherTable: "velox_binary", 
                            thisField: "p_ref", otherField: "table_uid", name: "binary", joinSearch: {table_name:"part"}
                        },  
                    ]}
                ] }
            ]},
            {otherTable: "part", joins: [
                {otherTable: "link_part_part", thisField:"p_ref", otherField: "part_parent", type:"2many", name: "parts", orderBy:"part_child", joins: [
                    {otherTable: "part", thisField: "part_child", otherField: "p_ref", flatten: true, joins : [
                        {otherTable: "part_exploded_position", name: "position", joinSearch: {e_id: "$pk"}, flatten: true},
                        { 
                            otherTable: "velox_binary", 
                            thisField: "p_ref", otherField: "table_uid", name: "binary", joinSearch: {table_name:"part"}
                        },  
                    ]}
                ] }
            ]}
        ]
    }
});


explodedController.gridController.onDisplayed = function(){
    if(!window.chrome){
        return this.view.error(VeloxWebView.tr("exploded.mustUseChrome")) ;
    }
} ;

explodedController.formController.prepareDataOnEnter = function(data, callback){
    this.api.api.multiread({
        part: {search: {}, joinFetch: [{otherTable: "link_part_part", otherField : "part_parent", thisField: "p_ref", name : "subPart"}]}
    }, function(err, reads){
        if(err){ return callback(err) ;}
        VeloxFormController.prototype.prepareDataOnEnter.call(this, data, function(err, data){
            if(err){ return callback(err) ;}
            this.initParts(data) ;
            data.partsWithSubParts = reads.part.filter(function(p){ return p.subPart ;}) ;
            callback(null, data) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

explodedController.formController.initParts = function(data){
    data.parts = data.device?data.device.parts:data.part?data.part.parts:[] ;
    var colors = palette('tol-rainbow', data.parts.length);
    for(var i=0; i<data.parts.length; i++){
        data.parts[i].color = "#"+colors[i] ;
        // var red = Number(colors[i].substring(0,2)) ;
        // var green = Number(colors[i].substring(2,4)) ;
        // var blue = Number(colors[i].substring(4,6)) ;
        // var brightness = Math.sqrt(
        //     red * red * .299 +
        //     green * green * .587 +
        //     blue * blue * .114); 
        //data.parts[i].colorText = (brightness < 130) ? "black" : "white"; ;
        data.parts[i].colorText =  "white"; 
    }
} ;

explodedController.formController.searchRecord = function(data, callback){
    VeloxFormController.prototype.searchRecord.call(this, data, function(err, data){
        if(err){ return callback(err) ;}
        ///readBinary/inline/__data__?${new Date().getTime()}
        this.initParts(data) ;
        if(data.binary){
            this.api.readBinary.url(data.binary, function(err, urlSvg){
                if(err){ return callback(err) ;}
                var xhr = new XMLHttpRequest();
                xhr.open("GET", urlSvg);
                xhr.onreadystatechange = (function () {
                    if (xhr.readyState === 4){
                        var responseResult = xhr.responseText ;
                        if(xhr.status >= 200 && xhr.status < 300) {
                            data.svg = responseResult ;
                            callback(null, data);
                        } else {
                            callback(responseResult||xhr.status);
                        }
                    } 
                }).bind(this);
                xhr.send();
            })  ;
        }else{
            callback(null, data) ;
        }
    }.bind(this));
} ;

explodedController.formController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    setTimeout(function(){
        var records = [] ;
        
        if(!viewData.e_id){
            viewData.e_id = uuid.v4() ;
        }
        records.push({table: "exploded", record: viewData}) ;
        
        records.push({table: "part_exploded_position", action: "removeWhere", record: {e_id: viewData.e_id}}) ;
    
        this.view.computeBounds(function(){
            viewData.parts.forEach(function(p){
                var bounds = [] ;
                if(p.pos_svg_coord && p.pos_svg_coord.length>0){
                    var svg = this.view.EL.svg.querySelector("svg") ;
                    p.pos_svg_coord.forEach(function(xpath){
                        var pathArray = xpath.slice(0) ;
                        var currentNode = svg ;
                        while(pathArray.length>0 && currentNode){
                            var index = pathArray.shift() ;
                            currentNode = currentNode.childNodes[index] ;
                        }
                        if(currentNode && currentNode!==svg){
                            bounds.push({
                                y: currentNode.bound_y, 
                                x: currentNode.bound_x, 
                                height:currentNode.bound_height, 
                                width:currentNode.bound_width,
                            }) ;
                        }
                    }) ;
                }

                records.push({table: "part_exploded_position", action:"insert", record: {
                    pos_id: uuid.v4(), 
                    e_id: viewData.e_id, 
                    p_ref: p.p_ref, 
                    pos_number: p.pos_number, 
                    pos_nopos: p.pos_nopos, 
                    pos_svg_coord: p.pos_svg_coord,
                    pos_bounds: bounds 
                }}) ;
            }.bind(this)) ;

            delete viewData.svg ;
            delete viewData.parts ;
            return callback(null, records) ;

        }.bind(this)) ;
    }.bind(this), 1000) ;
};

/**
 * User change the device
 */
explodedController.formController.onDevice = function(){
    this.view.updateData() ;
    if(!this.data.d_ref){
        this.data.parts = [] ;
        this.view.render() ;
        return;
    }
    this.view.longTask(function(done){
        this.api.api.device.getByPk(this.data.d_ref, [
            {otherTable: "link_part_device", type:"2many", name: "parts", orderBy: "p_ref", joins: [
                {otherTable: "part", flatten: true,  joins : [
                    { 
                        otherTable: "velox_binary", 
                        thisField: "p_ref", otherField: "table_uid", name: "binary", joinSearch: {table_name:"part"}
                    },  
                ] }
            ] }
        ], function(err, device){
            if(err){ return done(err) ;}
            this.data.device = device ;
            this.initParts(this.data) ;
            this.view.render() ;
            done() ;
        }.bind(this)) ;
    }.bind(this));
};

/**
 * User change the part
 */
explodedController.formController.onPart = function(){
    this.view.updateData() ;
    if(!this.data.p_ref){
        this.data.parts = [] ;
        this.view.render() ;
        return;
    }
    this.view.longTask(function(done){
        this.api.api.part.getByPk(this.data.p_ref, [
            {otherTable: "link_part_part", thisField:"p_ref", otherField: "part_parent", type:"2many", name: "parts", orderBy:"part_child", joins: [
                {otherTable: "part", thisField: "part_child", otherField: "p_ref", flatten: true, joins : [
                    { 
                        otherTable: "velox_binary", 
                        thisField: "p_ref", otherField: "table_uid", name: "binary", joinSearch: {table_name:"part"}
                    }, 
                    {otherTable: "part_exploded_position", name: "position", joinSearch: {e_id: "$pk"}, flatten: true}
                ]}
            ] }
        ], function(err, part){
            if(err){ return done(err) ;}
            this.data.part = part ;
            this.initParts(this.data) ;
            this.view.render() ;
            done() ;
        }.bind(this)) ;
    }.bind(this));
};

explodedController.formController.loadImageFile = function(file, done){
    var reader = new FileReader();
    
    reader.onload = function (e) {
        var data = this.view.getBoundObject() ;
        this.view.updateData() ;
        data.svg = e.target.result ;
        for(var y=0; y<data.parts.length; y++){
            if(data.parts[y].pos_svg_coord){
                data.parts[y].pos_svg_coord = [] ;
            }
        }
        this.view.render() ;
        done() ;
    }.bind(this);

    reader.readAsText(file);
} ;


module.exports = explodedController ;